<template>
    <div style="margin-bottom: 20px;">
        <div class="input-tags-wrap">
            <div class="tags mb-3">
                <div
                    v-for="(item, index) in currentTags.filter(t => t.tagType == taskPrefix)"
                    :key="item.id"
                    class="wrap-tag"
                >
                    <UserAvatar
                        :user="item"
                        size="medium"
                        v-if="taskPrefix == 'user'"
                    ></UserAvatar>
                    <span v-if="taskPrefix == 'user'">{{ item.username }}</span>
                    <i v-if="taskPrefix == 'tag'" :style="{ 'color': `${item.color}` }" :class="`icon-${item.symbol}`"></i>
                    <span v-if="taskPrefix == 'tag'">{{ item.name }}</span>
                    <span class="delete-tag" @click.prevent="removeTag(item)"></span>
                </div>

                <div 
                    class="tags-search-filter__btn"
                    @click="onTagsPlusClick()"
                >
                    +
                </div>
                <div class="relative-container">
                    <div class="dropdown" v-if="isDropdownOpened">
                        <input
                            ref="searchInput"
                            v-model="searchTag"
                            type="text"
                            class="text-input tags-dropdown-input"
                            placeholder="Search..."
                            @blur="clearTagSearch()"
                            @focus="isTagInputFocused = true"
                        />
    
                        <div v-for="item in tagSearchResult">
                            <div class="flex-gap-9 dropdown-item" v-if="taskPrefix == 'user'" @click="addUserExisting(item)">
                                <UserAvatar
                                    v-if="taskPrefix == 'user'"
                                    :user="item"
                                    size="medium"
                                ></UserAvatar>
                                <p class="tags-username">
                                    {{ item['username'] }}
                                </p>
                            </div>
                            <div class="flex-gap-9 dropdown-item" v-else @click="addTagExisting(item)">
                                <i :style="{ 'color': `${item.color}` }" :class="`icon-${item.symbol}`"></i>
                                <p class="tags-username">{{ item['name'] }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import UserAvatar from "@/components/atoms/UserAvatar.vue";
import Dropdown from "@/components/atoms/Dropdown.vue";

export default {
    name: "EditTask",
    components: {
        Flash,
        Textfield,
        TextArea,
        Dropmenu,
        UserAvatar,
        Dropdown,
    },
    props: ["tags", "task", "taskPrefix"],
    data: function () {
        return {
            lostConnection: false,
            searchTag: null,
            isTagInputFocused: false,
            currentTags: [],
            isDropdownOpened: false
        };
    },
    computed: {
        tagSearchResult() {
            if (this.searchTag && this.tags) {
                return this.tags.filter((item) => {
                    return item['username']?.toLowerCase().includes(this.searchTag.toLowerCase()) || item['name'].toLowerCase().includes(this.searchTag.toLowerCase());
                });
            }
            return this.tags; // Return original tags if no search or no tags available
        },

        searchTags() {
            return this.searchTag?.toLowerCase().split(" ");
        },
    },
    mounted() {
        //TODO This logic needs to be updates we could avoid using extra watcher in this case
        //currentTags could be a computed value, but we need to rewrite add/remove Tag functionality
        if (this.task.tags && this.task.tags.length > 0) {
            this.currentTags = this.task.tags.filter(t => t && t.id)
        }
    },
    methods: {
        async addUserExisting(tag) {
            tag['tagType'] = this.taskPrefix
            this.searchTag = ""

            if(!this.currentTags) {
                this.currentTags = []
            }

            let currentTagsIDs = this.currentTags.filter(t => t?.tagType == 'user').map(t => t.id)
            if(!currentTagsIDs.includes(tag['id'])) {
                this.currentTags.push(tag)
                this.task.tags = this.currentTags
                this.$store.dispatch('editTaskTags', this.task)

                try {
                    const data = {
                        id: this.task.id,
                        tags: this.currentTags.map(t => `${t['tagType']}:${t['id']}`),
                    };
                    const response = await api.post(`/task_edit`, data);

                    if (response.data.msg == 'ok') {
                        this.$emit('tagsUpdate')
                    }

                } catch (e) {
                    console.error(e);
                }
            }
        },
        async addTagExisting(tag) {
            tag['tagType'] = this.taskPrefix
            this.searchTag = ""

            if(!this.currentTags) {
                this.currentTags = []
            }
            
            let currentTagsIDs = this.currentTags.filter(t => t?.tagType == 'tag').map(t => t.id)
            if(!currentTagsIDs.includes(tag['id'])) {
                this.currentTags.push(tag)
                this.task.tags = this.currentTags
                this.$store.dispatch('editTaskTags', this.task)

                try {
                    const data = {
                        id: this.task.id,
                        tags: this.currentTags.map(t => `${t['tagType']}:${t['id']}`),
                    };
                    const response = await api.post(`/task_edit`, data);

                    if (response.data.msg == 'ok') {
                        this.$emit('tagsUpdate')
                    }

                } catch (e) {
                    console.error(e);
                }
            }
        },
        async removeTag(tag) {
            this.task.tags.splice(this.task.tags.findIndex(t => t.id == tag.id && t.tagType == tag.tagType), 1)
            this.currentTags.splice(this.currentTags.findIndex(t => t.id == tag.id && t.tagType == tag.tagType), 1)
            this.$store.dispatch('editTaskTags', this.task)
            
            try {
                const data = {
                    id: this.task.id,
                    tags: this.currentTags.map(t => `${t['tagType']}:${t['id']}`),
                };
                const response = await api.post(`/task_edit`, data);
                if (response.data.msg == 'ok') {
                    this.$emit('tagsUpdate')
                }

            } catch (e) {
                console.error(e);
            }
        },
        clearTagSearch() {
            setTimeout(() => {
                this.searchTag = ''
                this.isTagInputFocused = false
                this.isDropdownOpened = false
            }, 250)
        },
        onTagsPlusClick() {
            this.isDropdownOpened = !this.isDropdownOpened;
            setTimeout(() => {
                this.$refs.searchInput?.focus();
            }, 100);
        },
    },
    watch: {
        task: {
            handler() {
                this.currentTags = this.task?.tags.filter(t => t && t.id)
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
.title-wrap {
    margin-bottom: 19px;
    margin-top: 25px;
    
    h2 { margin: 0; }
    i { font-size: 23px; }
}
.tags-title {
    text-align: left;
    font-weight: 400;

    i {
        font-size: 20px;
    }
}

.input-tags-wrap {
    display: flex;
    gap: 5px;
}


.tags {
    display: flex;
    gap: 5px;

    .wrap-tag {
        margin: 0;
        background: var(--primary-bg);
        border: 0.5px solid var(--outline);
    }
}
.search-filter-wrap {
    position: relative;
    margin-top: 5px;
}

.tags-search-filter {
    border-radius: 6px;
    height: 30px;
    width: 306px;

    &__btn {
        display: inline-block;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        border-radius: 10px;
        background: var(--primary-bg);
        border: 0.5px solid var(--outline);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover {
            border: 1px solid var(--outline-active);
        }
    }

    img {
        width: 10px;
        margin-left: 6px;
        margin-bottom: 2.5px;
    }
}

.tags-search-results {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    z-index: 2;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 0.5rem;
    padding: 0.625rem;
    width: 100%;
}

.text-input {
    border: 0.5px solid var(--outline);
    background-color: var(--primary-bg);
    border-radius: 10px;
    width: 100%;
    outline: none;
    display: block;
    color: rgb(17, 24, 39);
    height: 100%;
    position: relative;
    padding-right: 20px;

    &:focus {
        border: 1px solid var(--outline-active);
    }
}

.task-boby-html h1 {
    font-size: 36px;
}

.task-boby-html h2 {
    font-size: 32px;
}
.search-tags-options-container {
    position: absolute;
    top: 35px;
    max-height: 232px;
    overflow-y: auto;
    width: 306px;
    border-radius: 6px;
    border: 1px solid #CFCFCF;
    background: #50555A;
    z-index: 1;
    padding: 10px 3px;

    div {
        margin: 0;
        padding: 2px 6px;
        cursor: pointer;
        transition: 100ms ease-in-out background-color, 100ms ease-in-out padding;
        border-radius: 6px;

        &:hover {
            background-color: $blue-hover;
        }

        p {
            display: inline-block;
        }
    }

    &.createTag {
        div {
            color: $gray-3;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }
    }
}

.relative-container {
    position: relative;
    width: 100%;
    height: 0;

    .dropdown {
        position: absolute;
        top: 0;
        width: 306px;
        padding: 8px;
        z-index: 2;
      }


    .tags-username {
        margin: 0;
    }
}
</style>
